import React from 'react';
import "../Figure.css";


export function Figure12() {
  return (
    <div>
        <table class="equal-width-table">
          <thead>
            <tr>
              <th></th>
              <th> Dilution</th>
              <th> Initial count </th>
              <th> Mucus </th>
              <th> % </th>
            </tr>
          </thead>
          <tbody>
          <tr>
              <th> Control </th>
              <td> 1:10 </td>
              <td> 724 </td>
              <td> 10 </td>
              <td> 1.38% </td>
            </tr>           
            <tr>
              <th>  </th>
              <td> 1:100 </td>
              <td> 96 </td>
              <td> 1 </td>
              <td> 1.04% </td>
            </tr> 
            <tr>
              <th>  </th>
              <td> </td>
              <td>  </td>
              <td>  </td>
              <td> </td>
            </tr>
            <tr>
              <th> D1D2 </th>
              <td> 1:1 </td>
              <td> 311 </td>
              <td> 75 </td>
              <td> 24.11% </td>
            </tr>           
            <tr>
              <th>  </th>
              <td> 1:10 </td>
              <td> 37 </td>
              <td> 15 </td>
              <td> 40.5% </td>
            </tr> 
            <tr>
              <th>  </th>
              <td> </td>
              <td>  </td>
              <td>  </td>
              <td> </td>
            </tr>
            <tr>
              <th> D2 </th>
              <td> 1:1 </td>
              <td> 185 </td>
              <td> 16 </td>
              <td> 8.64% </td>
            </tr>           
            <tr>
              <th>  </th>
              <td> 1:10 </td>
              <td> 11 </td>
              <td> 2 </td>
              <td> 18.18% </td>
            </tr> 
            <tr>
              <th>  </th>
              <td> </td>
              <td>  </td>
              <td>  </td>
              <td> </td>
            </tr>
          </tbody>
        </table>
    </div>
  );
}


export function Figure16() {
  return (
    <div>
        <table class="equal-width-table">
          <thead>
            <tr>
              <th> Sample 1 </th>
              <th> Sample 2 </th>
              <th> p-value </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td> D2 </td>
              <td> D2 uninduced </td>
              <td> 2.07383E-11 </td>
            </tr>             
            <tr>
              <td> D2 </td>
              <td> D2 permeable </td>
              <td> 0.001198045 </td>
            </tr> 
            <tr>
              <td> D2 uninduced </td>
              <td> D2 permeable </td>
              <td> 1.51969E-11 </td>
            </tr> 
          </tbody>
        </table>
    </div>
  );
}
